/* Áreas de atuação, benefícios e os documentos que cada um exige.
   Para incluir um benefício novo, basta acrescentar aqui. */
/* catalogo de documentos */
export const DOCS_CAT={
  rg:"RG", cpf:"CPF", end:"Comprovante de endereço",
  nasc:"Certidão de nascimento ou casamento", ctps:"Carteira de trabalho",
  caf:"CAF", terra:"Contrato de terra", parceria:"Contrato de parceria",
  laudo:"Laudo médico", cadunico:"CadÚnico", cnis:"CNIS",
  certfilho:"Certidão de nascimento do filho", declsind:"Declaração do sindicato",
  procuracao:"Procuração assinada"
};

/* area -> beneficio -> documentos exigidos */
export const AREAS=[{
  id:"prev", nome:"Previdenciária",
  beneficios:[
    {id:"sm",     nome:"Salário-maternidade",            cod:"B80",
     obrig:["cpf","end","certfilho","caf"], opc:["rg","terra","parceria","declsind","ctps"]},
    {id:"bpcinc", nome:"BPC/LOAS por incapacidade",       cod:"B87",
     obrig:["cpf","end","laudo","cadunico"], opc:["rg","nasc"]},
    {id:"bpcid",  nome:"BPC/LOAS por idade",              cod:"B88",
     obrig:["cpf","end","cadunico"], opc:["rg","nasc"]},
    {id:"apidr",  nome:"Aposentadoria por idade rural",   cod:"B41",
     obrig:["cpf","end","caf","terra"], opc:["rg","parceria","declsind","nasc","ctps"]},
    {id:"apid",   nome:"Aposentadoria por idade",         cod:"B41",
     obrig:["cpf","end","ctps"], opc:["rg","cnis","nasc"]},
    {id:"apinc",  nome:"Aposentadoria por incapacidade",  cod:"B32",
     obrig:["cpf","end","laudo","ctps"], opc:["rg","cnis","nasc"]},
    {id:"auxtmp", nome:"Auxílio por incapacidade temporária", cod:"B31",
     obrig:["cpf","end","laudo"], opc:["rg","ctps","cnis"]}
  ]
}];
export const BENEF=Object.fromEntries(AREAS.flatMap(a=>a.beneficios.map(b=>[b.id,{...b,area:a.id}])));
export const ESTADOS_CIVIS=["solteiro(a)","casado(a)","união estável","divorciado(a)","viúvo(a)","separado(a)"];

export function docsDoCaso(c){
  const b=BENEF[c?.beneficio]; if(!b) return {obrig:[], opc:["rg"]};
  return {obrig:b.obrig,opc:b.opc};
}
export function progresso(c){
  const {obrig}=docsDoCaso(c);
  if(!obrig.length) return {feito:0,total:0,pct:0};
  const tem=new Set((c.anexos||[]).map(a=>a.slot).filter(Boolean));
  const feito=obrig.filter(k=>tem.has(k)).length;
  return {feito,total:obrig.length,pct:Math.round(feito/obrig.length*100)};
}
export function fichaCompleta(c){
  /* RG não entra: o CPF já identifica o outorgante na procuração. */
  return !!(c.cliente&&c.cpf&&c.nascimento&&c.endereco&&c.cidade&&c.uf&&c.tel1);
}
